import * as React from 'react';
import { VendorViewModel } from '@models/Vendor';
import { Control, Errors, Form } from 'react-redux-form';
// import { hasDateValue, getDefaultErrorMessages, isDecimal } from '@common/validators';
import { getDefaultErrorMessages, isDecimal, valueIsLessThanN } from '@common/validators';

import { CheckboxInline } from '@common/components';
import { hasValue, isNumeric } from '../../../../../common/validators';
import { parseCurrency } from '@common/parsers';
import { DynamicSelectIdentifier } from '@common/components/dynamic-select/dynamic-select-types';
import { Select } from '../../../../../common/components/select/select';
import FormNames from '@constants/FormNames.enum';

export interface CoverageNLimitsComponentProperties {
  readonly vendorVM: VendorViewModel;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly onSaveClick: (model: VendorViewModel) => void;
}

export class CoverageNLimitsComponent extends React.Component<CoverageNLimitsComponentProperties> {
  render() {
    return (
      <div>
        {!this.props.vendorVM.id && <h2>Step 3 - Vendor Profile - Coverage & Limits</h2>}
        <Form model={FormNames.VendorCoverageNLimits} hideNativeErrors={true} onSubmit={this.props.onSaveClick}>
          <div className="row middle-xs">
            <div className="form-control col-xs-3">
              <label htmlFor=".agreementType.id">Agreement</label>
              <Select identifier={DynamicSelectIdentifier.VendorAgreementTypes} model=".agreementType.id" />
              <Errors
                className="error error-pad"
                model=".agreementType.id"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
            <div className="form-control col-xs-3">
              <label htmlFor=".dispatchLimitPermanent">Permanent Dispatch Limit</label>
              <Control.text
                model=".dispatchLimitPermanent"
                validators={{ required: hasValue, isNumeric, isSmallInt: valueIsLessThanN(32768) }}
                type="number"
              />
              <Errors
                className="error error-pad"
                model=".dispatchLimitPermanent"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
            <div className="form-control col-xs-3">
              <label htmlFor=".dispatchLimitTemp">Temporary Dispatch Limit</label>
              <Control.text
                model=".dispatchLimitTemp"
                validators={{ isDecimal, isNumeric, isSmallInt: valueIsLessThanN(32768) }}
                type="number"
              />
              <Errors
                className="error error-pad"
                model=".dispatchLimitTemp"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-control col-md-3">
              <label htmlFor=".hourlyRate">Hourly Rate</label>
              <Control.text
                validators={{ required: hasValue, isDecimal, lessThan10000: valueIsLessThanN(10000) }}
                min="0.00"
                step="0.01"
                type="number"
                parser={parseCurrency}
                updateOn="change"
                model=".hourlyRate"
              />
              <Errors
                className="error error-pad"
                model=".hourlyRate"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
            <div className="form-control col-md-3">
              <label htmlFor=".overtimeRate">Overtime Rate</label>
              <Control.text
                min="0.00"
                step="0.01"
                type="number"
                parser={parseCurrency}
                validators={{ isDecimal, lessThan10000: valueIsLessThanN(10000) }}
                updateOn="change"
                model=".overtimeRate"
              />
              <Errors
                className="error error-pad"
                model=".overtimeRate"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
            <div className="form-control col-md-3">
              <label htmlFor=".weekendRate">Weekend Rate</label>
              <Control.text
                min="0.00"
                step="0.01"
                type="number"
                validators={{ isDecimal, lessThan10000: valueIsLessThanN(10000) }}
                updateOn="change"
                model=".weekendRate"
                parser={parseCurrency}
              />
              <Errors
                className="error error-pad"
                model=".weekendRate"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
          </div>
          <div className="row">
            <div className="form-control col-md-3">
              <label htmlFor=".emergencyRate">Rush/Emergency Rate</label>
              <Control.text
                min="0.00"
                step="0.01"
                type="number"
                validators={{ required: hasValue, isDecimal, lessThan10000: valueIsLessThanN(10000) }}
                updateOn="change"
                model=".emergencyRate"
                parser={parseCurrency}
              />
              <Errors
                className="error error-pad"
                model=".emergencyRate"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
            <div className="form-control col-md-3">
              <label htmlFor=".secondWorkerRate">Second Man Rate</label>
              <Control.text
                min="0.00"
                step="0.01"
                type="number"
                validators={{ required: hasValue, isDecimal, lessThan10000: valueIsLessThanN(10000) }}
                updateOn="change"
                model=".secondWorkerRate"
                parser={parseCurrency}
              />
              <Errors
                className="error error-pad"
                model=".secondWorkerRate"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
            <div className="form-control col-md-3">
              <label htmlFor=".diagnosticRate">Diagnostic Rate</label>
              <Control.text
                min="0.00"
                step="0.01"
                type="number"
                validators={{ isDecimal, lessThan10000: valueIsLessThanN(10000) }}
                updateOn="change"
                model=".diagnosticRate"
                parser={parseCurrency}
              />
              <Errors
                className="error error-pad"
                model=".diagnosticRate"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
          </div>
          <div className="row middle-xs">
            <div className="form-control col-md-3">
              <label htmlFor=".authoLimit">Autho Limit</label>
              <Control.text
                min="0.00"
                step="0.01"
                type="number"
                validators={{ required: hasValue, isDecimal, lessThan10000: valueIsLessThanN(10000) }}
                updateOn="change"
                model=".authoLimit"
                parser={parseCurrency}
              />
              <Errors
                className="error error-pad"
                model=".authoLimit"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
            </div>
          </div>
          <div className="row middle-xs">
            <div className="form-control col-xs-4">
              <CheckboxInline>
                <Control.checkbox model=".statReport" />
                <label htmlFor=".statReport">Stat Report</label>
              </CheckboxInline>
              <CheckboxInline>
                <Control.checkbox model=".vendorPortal" />
                <label htmlFor=".vendorPortal">Vendor Portal</label>
              </CheckboxInline>
            </div>
            <div className="form-control col-xs-4">
              <CheckboxInline>
                <Control.checkbox model=".autoRerating" />
                <label htmlFor=".autoRerating">Auto Rerating</label>
              </CheckboxInline>
              <CheckboxInline>
                <Control.checkbox model=".onlineAutho" />
                <label htmlFor=".onlineAutho">Online Autho</label>
              </CheckboxInline>
            </div>
            <div className="form-control col-xs-4">
              <CheckboxInline>
                <Control.checkbox model=".reportCard" />
                <label htmlFor=".reportCard">Report Card</label>
              </CheckboxInline>
              <CheckboxInline>
                <Control.checkbox model=".noBidding" />
                <label htmlFor=".noBidding">No Bidding</label>
              </CheckboxInline>
            </div>
          </div>
          <div className="col-md-1">
            <button className="btn btn-hidden" type="submit" ref={this.props.buttonRef}>
              {/*ref={this.props.buttonRef}>*/}
              Save
            </button>
          </div>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/steps/coverage-n-limits/coverage-n-limits.component.tsx